<template>
	<div class="section pride-stonewall-inn-container" v-bind:style="{ 'background-image': 'url(' + getImgUrl(stonewall.BG_IMAGE) + ')' }" ref="stonewall">
		<div class="pride-inner">
			<img class="" :src="getImgUrl(stonewall.IMG_1)" id="stoneall-logo"  />
			<h1 v-html="stonewall.HEADER"></h1>
			<p v-html="stonewall.COPY"></p>
			<a v-bind:href="stonewall.BTN_LINK">
				<button v-html="stonewall.BTN_COPY" class="pride-btn"></button>
			</a>
		</div>
	</div>
</template>

<script>

	import isIntersectingMixin from '../../mixins/isIntersectingMixin';

	export default {
		name: "pride-stonewall-inn",
		mixins: [isIntersectingMixin],
		props: {
			stonewall: {
				type: Object,
			}
		},
		// data(){
		// 	return{
		// 		observer : null
		// 	}
		// },
		// mounted(){
		// 	this.observer = new IntersectionObserver(this.onIntersect, {
		// 		root: null,
		// 		rootMargin: '0px 0px 0px 0px',
		// 		threshold: .5,
		// 	})

		// 	this.observer.observe(this.$el)
		// },
		// destroyed(){
		// 	this.observer.disconnect()
		// 	this.observer = null
		// },
		methods: {
			getImgUrl: place => {
				const images = require.context(
					"./../../assets/pride/",
					false
				);
				return  images("./" + place) 
			},

			onIntersect(event) {
				const stonewall = this.$refs.stonewall;
				const isIntersecting = event.find((entry) => {
					return entry.isIntersecting
				})
				if (isIntersecting) {
					this.$emit('intersect', event)
					stonewall.querySelector('h1').classList.add("header_ani");
					stonewall.querySelector('p').classList.add("copy_ani");
					stonewall.querySelector('.pride-btn').classList.add("btn_ani");
				}
			},
		}
	}
</script>

<style lang='scss'>

	.pride-stonewall-inn-container {
		background-size: cover;
		background-repeat: no-repeat;
		background-position: center center;
		@media (min-width: 768px) {
					background-attachment: fixed;
		}

		h1, p {
			opacity: 0;
		}

		.pride-btn {
			opacity: 0;
		}

		.btn_ani {
			animation: btn_ani 1s forwards;
			animation-delay: .5s;
		}
		.header_ani {
			animation: move 1s forwards;
			animation-delay: 100ms;
		}

		.copy_ani {
			animation: move 1s forwards;
			animation-delay: 100ms;
		}

		@media (min-width: 768px) {
			min-height: 732px;
		}

		.pride-inner {
			padding: 3em 0;
			max-width: 1050px;

			@media (min-width: 768px) {
				padding: 0;
			}

		}
		
		#stoneall-logo {
			width: 60%;
			margin-bottom: 2em;

			@media (min-width: 768px) {
				width: 35%;
			}
		}

		@keyframes btn_ani {
			from {
				transform: translateY(100%);
				opacity: 0;
			}

			to {
				transform: translateY(0%);
				opacity: 1;
			}
		}

		@keyframes move {
			from {
				transform: translateY(100%);
				opacity: 0;
			}

			to {
				transform: translateY(0%);
				opacity: 1;
			}
		}

	}

</style>



// WEBPACK FOOTER //
// src/components/pride/PrideStonewallInn.vue